import { useState } from 'react';

import { calendarZone } from '../../shared/calendar';

import { workspace } from '../lib/engine';
import { Button, Input } from './ui';

export const SETTINGS_ID = 'ca110000-0000-4000-8000-000000000001';

export function WorkspaceSettings() {
  const [zone, setZone] = useState(calendarZone()),
    [error, setError] = useState('');

  return (
    <form
      className="detail-card"
      onSubmit={async e => {
        e.preventDefault();

        try {
          new Intl.DateTimeFormat('en', { timeZone: zone }).format();

          await workspace.save(SETTINGS_ID, 'settings', {
            ...workspace.snapshot().records.find(r => r.kind === 'settings')?.value,
            timezone: zone,
          });

          setError('');
        } catch (e) {
          setError((e as Error).message);
        }
      }}
    >
      <h2>Workspace timezone</h2>
      <label>
        IANA timezone
        <Input list="timezones" value={zone} onChange={e => setZone(e.target.value)} />
      </label>
      <datalist id="timezones">
        {Intl.supportedValuesOf('timeZone').map(zone => (
          <option key={zone} value={zone} />
        ))}
      </datalist>
      <p>
        Calendar days, birthdays, task completion dates and review weeks use this timezone. Existing
        event instants are retained.
      </p>
      {error && <p className="error-message">{error}</p>}
      <Button variant="secondary">Save timezone</Button>
    </form>
  );
}
